import SecureStorage from './secure-storage';

// eslint-disable-next-line import/no-default-export
export default SecureStorage;
